import * as React from 'react';
import * as Core from 'components/core';
import { User } from 'types/user';
import SwitchUser from 'app/actionCreators/SwitchUser';
type Props = {
  authenticatingUser: User;
  currentUser: User;
};
type State = {
  loginEmail: string;
  error: string | undefined | null;
};
export default class UserSwitcher extends React.Component<Props, State> {
  state = {
    loginEmail: '',
    error: null,
  };
  updateLoginEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      loginEmail: event.currentTarget.value,
    });
  };
  switchSessionUser = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { currentUser } = this.props;
    SwitchUser(this.state.loginEmail, currentUser).catch((err) => {
      this.setState({
        error: err.message,
      });
    });
  };
  render() {
    const { authenticatingUser } = this.props;
    const { loginEmail, error } = this.state;
    return (
      <form onSubmit={this.switchSessionUser}>
        <Core.FormGroup label="Switch User" errorMessage={error}>
          <Core.Input
            value={loginEmail}
            onChange={this.updateLoginEmail}
            placeholder={authenticatingUser.LoginEmail}
          />
        </Core.FormGroup>
        <Core.FormGroup>
          <Core.Button>Go</Core.Button>
        </Core.FormGroup>
      </form>
    );
  }
}
